import React, { useEffect } from "react";

export default function useStickyState(defaultValue, key) {
  const [value, setValue] = React.useState(() => {
    const stickyValue = sessionStorage.getItem(key);
    const state = stickyValue !== null ? JSON.parse(stickyValue) : defaultValue;
    return state;
  });

  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
}

export function useLocalStickyState(defaultValue, key) {
  const [value, setValue] = React.useState(() => {
    const stickyValue = localStorage.getItem(key);
    const returnValue =
      stickyValue !== null ? JSON.parse(stickyValue) : defaultValue;
    return returnValue;
  });

  useEffect(() => {
    localStorage.setItem(key, value);
  }, [key, value]);

  return [value, setValue];
}
